// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3OEid","actionsCol":"EnrolledClinics_actionsCol__3kgkT"};